import { FC } from "react";
import Box from "@mui/material/Box";
import { MarketSizeByEmployeeChart } from "./MarketSizeByEmployeeChart";
import { MarketSizeByGeographyChart } from "./MarketSizeByGeographyChart";
import { MarketSizeByIndustryChart } from "./MarketSizeByIndustryChart";
import { MarketSizeByRevenueChart } from "./MarketSizeByRevenueChart";
import { MarketSizeBySegment } from "./MarketSizeBySegment/MarketSizeBySegment";
import { TopProductsSection } from "./TopProductsSection";
import Divider from "@mui/material/Divider";
import LazyRenderer from "../../../../components/LazyRenderer";
import { useIntersectionObserver } from "../../../../components/IntersectionObserver";

export const MarketLandscape: FC = () => {
  const { container } = useIntersectionObserver();

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap="10px"
      width="100%"
      minWidth={0}
      maxWidth="100%"
    >
      <MarketSizeBySegment />

      <Box
        display="flex"
        gap="10px"
        flexDirection={"row"}
        width="100%"
        minWidth={0}
        maxWidth="100%"
      >
        <Box flex={1} minWidth={0} maxWidth="100%">
          <LazyRenderer
            root={container.current || undefined}
            fallback={<></>}
            threshold={0.1}
          >
            <MarketSizeByGeographyChart />
          </LazyRenderer>
        </Box>
        <Box flex={1} minWidth={0} maxWidth="100%">
          <LazyRenderer
            root={container.current || undefined}
            fallback={<></>}
            threshold={0.1}
          >
            <MarketSizeByIndustryChart />
          </LazyRenderer>
        </Box>
      </Box>

      <Box
        display="flex"
        gap="10px"
        flexDirection="row"
        width="100%"
        minWidth={0}
        maxWidth="100%"
      >
        <Box flex={1} minWidth={0} maxWidth="100%">
          <LazyRenderer
            root={container.current || undefined}
            fallback={<></>}
            threshold={0.1}
          >
            <MarketSizeByRevenueChart />
          </LazyRenderer>
        </Box>
        <Box flex={1} minWidth={0} maxWidth="100%">
          <LazyRenderer
            root={container.current || undefined}
            fallback={<></>}
            threshold={0.1}
          >
            <MarketSizeByEmployeeChart />
          </LazyRenderer>
        </Box>
      </Box>

      <Divider />

      <TopProductsSection />
    </Box>
  );
};
